import React from "react";

/* Import Boostrap */
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

class TabTitle extends React.Component {       
    render () {
        return (
            <span>
                <span className="icon visible-xs"><i className={ this.props.icon }></i></span><span className="hidden-xs">{ this.props.translate(this.props.title) }</span>
            </span>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(TabTitle);


// WEBPACK FOOTER //
// ./src/components/tabs/tab-title.js